export const visit = (vm, at) => {
at({ "hu": { "conversationsVisitorUIAvailability": { "sameDay": "Ma visszat\xE9r\xFCnk ekkor: {{time}}", "nextDay": "Holnap visszat\xE9r\xFCnk ekkor: {{time}}", "nextWeek": "Visszat\xE9r\xFCnk ekkor: {{dayOfWeek}}, {{time}}" } } });
};